import { useMemo } from 'react';

import { ChatikProviderProps } from '@hh.ru/chatik-integration';

type InitParams = ChatikProviderProps['initParams'];

const useInitParams = (origin: string): InitParams => {
    const initParams = useMemo(
        () =>
            ({
                origin,
                incomingMessageHandlers: {
                    redirectTo: (data: { path: string }) => {
                        window.location.assign(data.path);
                    },
                },
            } as InitParams),
        [origin]
    );

    return initParams;
};
export default useInitParams;
